import { tokenInvalid } from "@/pages/App/native";
import { setLoginSize } from "@/utils/window";
import { HttpRequest, registerEncryptUrlPatterns, registerEncryptUrlExceptions, setAppEnv } from "@common/utils";
import userInfoStore from "@/store/user.store";
import loginInfoStore from "@/store/login.store";
import { isMobile } from "@/utils/platform";
import { debounce } from "lodash";
import { refreshUserToken } from "./api_user";
import { message } from "antd";
import { TOKEN_KEY, getPathnameWithoutBasename, shouldEncryptTransmission } from "@/config";
import { setKMSConfigEnabled } from "@common/utils/http/kmsConfig";

// 设置 KMS 环境变量（从 Vite 环境变量读取）
setAppEnv((import.meta.env.VITE_APP_ENV as 'dev' | 'test' | 'prod') || 'prod');

// 注册 web 包需要加解密的 URL 模式
registerEncryptUrlPatterns([
  // 企业模块
  'api/auth/user/enc/company/info',
  // 用户模块
  'api/auth/user/enc/info',
  'api/auth/user/enc/business/cancel',
  'api/guest/auth/login/enc/mobile-captchas/send',
  'api/guest/auth/login/enc/mobile',
  'api/guest/weixin/enc/bind',
  'api/guest/auth/login/enc/token/refresh',
]);

// 注册 web 包不需要加解密的 URL 例外规则（如果需要）
registerEncryptUrlExceptions([
  // 例如：某些特殊的认证接口不需要加密
  // '/api/auth/health-check',
]);

// 根据 shouldEncryptTransmission 判断是否启用 KMS 配置
setKMSConfigEnabled(shouldEncryptTransmission());

// 保存登录失效消息的句柄，用于确保只显示一个消息
let loginInvalidMessageHandle: ReturnType<typeof message.info> | null = null;

const tokenInvalidCb = () => {
  // const { failCb } = params;
  if (window.JSBridgeModel) {
    tokenInvalid();
    return;
  } else {
    // 如果已有消息在显示，直接返回，避免重复显示
    if (loginInvalidMessageHandle) {
      console.log("登录失效消息已显示，直接返回");
      return;
    }
    console.log("登录失效，显示消息");
    // 显示消息并保存句柄
    loginInvalidMessageHandle = message.info("登录失效，请重新登录", 3, () => {
      loginInvalidMessageHandle = null;
    });
    setLoginSize();
    userInfoStore.getState().resetUser();
    loginInfoStore.getState().setHasLogin(false);
    http.clearToken();
    // 防止被二次跳转
    if (location.search.includes('redirectUrl')) return;
    const params = {
      redirectUrl: getPathnameWithoutBasename() + location.search,
    };
    const search = new URLSearchParams(params).toString();
    if (isMobile()) {
      window.navigate(`/mobileLogin?${search}`);
    } else if (window.LinkService) {
      window.navigate("/login", { replace: true });
    } else {
      window.navigate(`/login?${search}`, { replace: true });
    }
    return;
  }
}

const refreshTokenCb = async (refreshToken: string) => {
  console.log('自动刷新 token');
  const data = await refreshUserToken(refreshToken);
  return data.refreshToken;
}

class HttpInstance {
  private static instance: HttpRequest;

  public static getInstance(): HttpRequest {
    if (!HttpInstance.instance) {
      HttpInstance.instance = new HttpRequest({
        baseURL: import.meta.env.VITE_BACKEND_URL,
        storageKey: TOKEN_KEY,
        tokenInvalidCb: debounce(tokenInvalidCb, 150),
        refreshTokenCb,
      });
    }
    return HttpInstance.instance;
  }
}

const http = HttpInstance.getInstance();

export default http;
